import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';

const SCOPE = 'betaTooltip';

type TooltipPosition = 'top-right' | 'inline';

@Component({
  selector: 'rma-beta-tooltip',
  templateUrl: './beta-tooltip.component.html',
  imports: [TranslocoModule, MatTooltipModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideTranslocoScope(SCOPE)],
  host: {
    '[class]': 'hostClass()',
  },
})
export class BetaTooltipComponent {
  protected readonly scope = SCOPE;

  public readonly position = input<TooltipPosition>('top-right');
  public readonly message = input<string | null>(null);

  public readonly hostClass = computed(() => {
    const position = this.position();
    const classes = this.positionClasses(position);
    return `${classes} mr-[.625rem] rounded-xs bg-white text-steel-60 border-steel-40 border uppercase px-1`;
  });

  private positionClasses(position: TooltipPosition) {
    switch (position) {
      case 'top-right':
        return 'block absolute z-10 -top-2 -right-4';
      case 'inline':
        return 'inline';
    }
  }
}
